module.exports = __webpack_public_path__ + "static/img/13.d120835.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/2/sp/13.png
// module id = sYes
// module chunks = 0